import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
    UserPoolId: "us-west-2_QA89Dim84",
    ClientId: "3iobcrcqt3ho2id417crt9rl8a"
}

export default new CognitoUserPool(poolData)